import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadAllTests = createAsyncThunk("tests/loadAllTests", async (_, thunkAPI) => {
  try {
    const response = await API("tests/all-tests");

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadAllPlusTests = createAsyncThunk("tests/loadAllPlusTests", async (websiteId, thunkAPI) => {
  try {
    const response = await API(`v3/bespoke-test/get-plus-tests/${websiteId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const checkAllPlusTests = createAsyncThunk("tests/checkAllPlusTests", async (websiteId, thunkAPI) => {
  try {
    const response = await API(`v3/bespoke-test/get-plus-tests/${websiteId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadTestInfo = createAsyncThunk("tests/loadTestInfo", async ({testId = 0, partnerId = 0}, thunkAPI) => {
  try {
    const response = await API(`/bespoke-test/get-parent-test/${testId}/${partnerId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadEditTestInfo = createAsyncThunk(
  "tests/loadEditTestInfo",
  async ({testId = 0, partnerId = 0}, thunkAPI) => {
    try {
      const response = await API(`/bespoke-test/get-edit-test/${testId}`);

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateBespokeLogs = createAsyncThunk("tests/updateBespokeLogs", async (payload, thunkAPI) => {
  try {
    const response = await API("bespoke-test/update-logs", {
      method: "POST",
      body: {...payload, url: payload.url || window.location.href},
    });

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const createNewTestUnsecure = createAsyncThunk("tests/createNewTestUnsecure", async (payload, thunkAPI) => {
  try {
    const response = await API("v2/bespoke-test/create-test", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const checkPlusTestAvailable = createAsyncThunk("tests/checkPlusTestAvailable", async (payload, thunkAPI) => {
  try {
    const response = await API("v2/bespoke-test/check-available-tests", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
